module.exports = __webpack_public_path__ + "img/20191216160854360截图20191216104943364.38c1e9e2.jpg";